import "../index.css";
import { useEffect } from "react";
import Footer from "../components/Footer";
import { PageNav } from "../components/PageNav";
import ContactForm from "../components/ContactForm";

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PageNav />
      <div className="bsp-page">
        <div className="bsp-section bsp-container-narrow font_family_base">
          <div className="bsp-eyebrow bsp-center">Contact</div>
          <h1 className="bsp-h1 bsp-center">Let's Start a Conversation</h1>
          <p className="bsp-lead bsp-center" style={{ marginBottom: 32 }}>
            Tell us a bit about what you're working through, and we'll follow up
            to find the right next step.
          </p>

          <div className="bsp-card-alt bsp-center" style={{ marginBottom: 40 }}>
            <div className="bsp-eyebrow">Fastest Way to Connect</div>
            <h2 className="bsp-h2">Schedule a Meeting</h2>
            <p className="bsp-body" style={{ marginBottom: 20 }}>
              Pick a time that works for you and book directly on the calendar
              &mdash; no back-and-forth required.
            </p>
            <a
              href="https://freebusy.io/armstrong.ba@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="bsp-btn bsp-btn-primary"
            >
              Book a Time
            </a>
          </div>

          <div className="bsp-center" style={{ marginBottom: 20 }}>
            <div className="bsp-eyebrow">Or Send a Message</div>
          </div>
          <div className="bsp-card">
            <ContactForm />
          </div>
          <p
            className="bsp-body bsp-center font_family_base"
            style={{ marginTop: 30 }}
          >
            Prefer email? Reach us directly at{" "}
            <a href="mailto:brian@bstrongperformance.com">
              brian@BStrongPerformance.com
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
